export interface HeroSlide {
  filmId: string;
  backdrop: string;
  headline: string;
  sub: string;
}

export const heroSlides: HeroSlide[] = [
  {
    filmId: "t1",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20fantasy%20backdrop%20of%20a%20warm%20midnight%20inn%20in%20an%20old%20town%20alley%2C%20glowing%20lanterns%20and%20magical%20guests%20in%20soft%20silhouette%2C%20deep%20violet%20shadows%20with%20warm%20amber%20highlights%2C%20mysterious%20atmosphere%2C%20dark%20enough%20for%20text%20overlay%2C%20high%20detail&width=1600&height=900&seq=fairy-hero-t1&orientation=landscape",
    headline: "妖精旅馆",
    sub: "一间只在午夜营业的旅馆，接待形形色色的妖精客人",
  },
  {
    filmId: "f5",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20wide%20dark%20fantasy%20backdrop%20of%20an%20ancient%20elven%20forest%20kingdom%20at%20night%2C%20towering%20trees%20and%20glowing%20runes%2C%20misty%20valley%20behind%20a%20lone%20silhouetted%20warrior%2C%20deep%20purple%20and%20teal%20lighting%2C%20cinematic%20and%20moody%2C%20dark%20enough%20for%20text%20overlay%2C%20high%20detail&width=1600&height=900&seq=fairy-hero-f5&orientation=landscape",
    headline: "暗夜精灵王国",
    sub: "精灵王国与暗影军团的史诗之战，公主踏上复国之路",
  },
  {
    filmId: "f1",
    backdrop:
      "https://readdy.ai/api/search-image?query=Ethereal%20wide%20moonlit%20backdrop%20of%20a%20giant%20full%20moon%20above%20a%20misty%20osmanthus%20grove%2C%20floating%20silver%20light%20particles%20and%20a%20distant%20fairy%20silhouette%2C%20lavender%20and%20cream%20moonlight%2C%20calm%20dreamy%20atmosphere%2C%20dark%20enough%20for%20text%20overlay%2C%20high%20detail&width=1600&height=900&seq=fairy-hero-f1&orientation=landscape",
    headline: "月影妖精",
    sub: "月圆之夜苏醒的妖精，与人间画师相遇的爱与救赎",
  },
  {
    filmId: "f11",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20wide%20summer%20night%20backdrop%20of%20a%20golden%20rice%20field%20filled%20with%20thousands%20of%20glowing%20fireflies%2C%20deep%20blue%20sky%20and%20distant%20mountain%20silhouettes%2C%20magical%20and%20nostalgic%20mood%2C%20dark%20enough%20for%20text%20overlay%2C%20high%20detail&width=1600&height=900&seq=fairy-hero-f11&orientation=landscape",
    headline: "萤火妖精",
    sub: "夏夜萤火汇聚而成的妖精，陪伴孤独少年度过整个夏天",
  },
  {
    filmId: "t7",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dark%20modern%20fantasy%20wide%20backdrop%20of%20a%20rainy%20city%20skyline%20at%20night%20with%20a%20glowing%20magical%20contract%20sigil%20floating%20in%20the%20air%2C%20melting%20memory%20light%20fragments%2C%20violet%20and%20amber%20neon%2C%20cinematic%20and%20mysterious%2C%20dark%20enough%20for%20text%20overlay%2C%20high%20detail&width=1600&height=900&seq=fairy-hero-t7&orientation=landscape",
    headline: "妖精的契约",
    sub: "签订契约便能实现愿望，代价却是最珍贵的记忆",
  },
];